import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const OverviewIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <g
      stroke={color}
      strokeWidth={1.5}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <path d="M2.766 13.63a7.856 7.856 0 0 1-1.113-4.044c0-4.382 3.574-7.936 7.984-7.936 4.408 0 7.982 3.554 7.982 7.936a7.86 7.86 0 0 1-1.113 4.044" />
      <path d="M9.12 13.117c0-.283.517-2.148.517-2.148s.516 1.865.516 2.148a.515.515 0 0 1-1.032 0zM9 1.908v2.95M15.927 5.708l-2.099 2.087M5.016 8.326L2.92 6.239" />
    </g>
  </svg>
);

OverviewIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

OverviewIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(19, 15),
};

export default OverviewIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/overview.js